var map = {
	"./wvt-g-001.jpg": 1541,
	"./wvt-g-0010.jpg": 4329,
	"./wvt-g-0011.jpg": 3276,
	"./wvt-g-0012.jpg": 5259,
	"./wvt-g-0013.jpg": 7214,
	"./wvt-g-0014.jpg": 9685,
	"./wvt-g-0015.jpg": 1816,
	"./wvt-g-0016.jpg": 9271,
	"./wvt-g-0017.jpg": 3434,
	"./wvt-g-002.jpg": 5290,
	"./wvt-g-003.jpg": 1127,
	"./wvt-g-004.jpg": 5132,
	"./wvt-g-005.jpg": 6185,
	"./wvt-g-006.jpg": 9070,
	"./wvt-g-007.jpg": 7115,
	"./wvt-g-008.jpg": 5504,
	"./wvt-g-009.jpg": 4077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3657;